
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, Mail } from "lucide-react";
import { useCreatorEmail } from "@/hooks/useCreatorEmail";

export const SupportTab = () => {
  const { creatorEmail, isLoading } = useCreatorEmail();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Course Support</CardTitle>
        <CardDescription>
          Need help or have a question? Contact your course creator directly.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">
              Connect with your course instructor for course-specific questions or assistance.
            </p>
            
            {creatorEmail ? (
              <>
                <a 
                  href={`mailto:${creatorEmail}`} 
                  className="block"
                >
                  <Button 
                    variant="secondary" 
                    className="w-full sm:w-auto"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    ) : (
                      <Mail className="mr-2 h-4 w-4" />
                    )}
                    Contact Course Creator
                  </Button>
                </a>
                
                <p className="text-xs text-muted-foreground mt-1">
                  This will open your email app to contact your course instructor.
                </p>
              </>
            ) : (
              <>
                <Button 
                  variant="secondary" 
                  className="w-full sm:w-auto"
                  disabled={true}
                >
                  {isLoading ? (
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  ) : (
                    <Mail className="mr-2 h-4 w-4" />
                  )}
                  Contact Course Creator
                </Button>
                
                <p className="text-xs text-muted-foreground mt-1">
                  Instructor contact information is not available.
                </p>
              </>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
